// MFA Types
export enum MFAMethodType {
  EMAIL = 'EMAIL',
  TOTP = 'TOTP',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export interface TOTPSetupData {
  qr_code: string;
  recovery_codes: string[];
  secret: string;
  /** Epoch ms after which Stytch rejects this registration and a new QR code is required. */
  expiresAt: number;
}
